// extracted by mini-css-extract-plugin
export var deskImage = "PremiumBlackicon-module--desk-image--16de2";
export var desktopImg = "PremiumBlackicon-module--desktopImg--65d36";
export var heroImg = "PremiumBlackicon-module--hero-img--575b9";
export var hide = "PremiumBlackicon-module--hide--3e1fb";
export var imgContainer = "PremiumBlackicon-module--imgContainer--15d07";
export var mobImage = "PremiumBlackicon-module--mob-image--67d92";
export var mobileImage = "PremiumBlackicon-module--mobileImage--bb905";
export var title = "PremiumBlackicon-module--title--288c3";